function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PriceVariantType } from "./priceMol.types";
export var pricesTypographies = _defineProperty(_defineProperty(_defineProperty({}, PriceVariantType.LARGE, {
  crossedPrice: {
    typography: "big2"
  },
  currentPrice: {
    typography: "sgiant_2"
  },
  periodText: {
    typography: "medium3_h"
  },
  badgeText: {
    typography: "tiny1",
    hasFitLineHeight: true
  },
  infoText: {
    typography: "nano1",
    hasFitLineHeight: true,
    emphasis: "medium"
  },
  promoText: {
    typography: "nano1",
    hasFitLineHeight: true
  },
  promoPrice: {
    typography: "nano2",
    hasFitLineHeight: true
  }
}), PriceVariantType.MEDIUM, {
  crossedPrice: {
    typography: "xsmall1"
  },
  currentPrice: {
    typography: "large3"
  },
  periodText: {
    typography: "xsmall1"
  },
  badgeText: {
    typography: "nano1",
    hasFitLineHeight: true
  },
  infoText: {
    typography: "nano1",
    hasFitLineHeight: true,
    emphasis: "medium"
  },
  promoText: {
    typography: "nano1",
    hasFitLineHeight: true
  },
  promoPrice: {
    typography: "nano2",
    hasFitLineHeight: true
  }
}), PriceVariantType.SMALL, {
  crossedPrice: {
    typography: "xsmall1"
  },
  currentPrice: {
    typography: "medium4_s"
  },
  periodText: {
    typography: "xsmall1"
  },
  badgeText: {
    typography: "nano1",
    hasFitLineHeight: true
  },
  infoText: {
    typography: "nano1",
    hasFitLineHeight: true,
    emphasis: "medium"
  },
  promoText: {
    typography: "nano1",
    hasFitLineHeight: true
  },
  promoPrice: {
    typography: "nano2",
    hasFitLineHeight: true
  }
});
export var elementsSpaces = _defineProperty(_defineProperty(_defineProperty({}, PriceVariantType.LARGE, {
  mainPrice: 2,
  additionalInformation: 2
}), PriceVariantType.MEDIUM, {
  mainPrice: 1.5,
  additionalInformation: 1.5
}), PriceVariantType.SMALL, {
  mainPrice: 1.5,
  additionalInformation: 1.5
});